export default __webpack_public_path__ + "img/de30a7c55f6ed0a3a096d755c4882e94.png";